import React, { useState } from "react";
import styles from "./SlidesCard.module.css";
import {
	titleL,
	titleS,
	fw500,
	fw400,
	primaryTextColor,
	secondaryTextColor,
	primaryBoxShadow,
} from "../../../Global.module.css";
import SlidesIcon from "../../../assets/google.svg";
import ShareIcon from "../../../assets/share.svg";
import FocusIcon from "../../../assets/focus.svg";
import EditIcon from "../../../assets/edit.svg";
import Duplicate from "../../../assets/duplicate.svg";
import DustbinIcon from "../../../assets/dustbin.svg";
import DropMenu from "../../reusable/DropMenu/DropMenu";
import IconTextButton from "../../reusable/Button/IconTextButton";
import { useHistory } from "react-router-dom";
import Routes from "../../../routes.json";
import MoreButton from "../../reusable/Button/MoreButton";
import { getLocalDate } from "../../../helpers/getDateTime";
import { duplicateSlides } from "../../../helpers/api";

export default function SlidesCard({
	index,
	data,
	openShareMenu,
	openDeleteMenu,
	initSlides,
}) {
	const history = useHistory();

	const [showDropMenu, setDropMenuState] = useState(false);

	const handleDropMenu = () => {
		setDropMenuState(!showDropMenu);
	};

	const handleShareButton = (index) => {
		handleDropMenu();
		openShareMenu(index);
	};

	const handleDeleteButton = async (index) => {
		handleDropMenu();
		openDeleteMenu(index);
	};

	const handleEditButton = () => {
		history.push(Routes.EditorPage + "/" + data.id);
	};

	const handleDuplicate = () => {
		handleDropMenu();
		duplicateSlides(data.id)
			.then((res) => {
				initSlides();
			})
			.catch((e) => {});
	};

	const handleView = () => {
		const win = window.open(Routes.ViewPage + "/" + data.id, "_blank");
		win.focus();
		handleDropMenu();
	};

	const getEditedDate = () => {
		return (
			"Edited: " + (getLocalDate(data.edited) || getLocalDate(Date.now()))
		);
	};

	const getCreatedDate = () => {
		return (
			"Created: " +
			(getLocalDate(data.created) || getLocalDate(Date.now()))
		);
	};

	const dropMenu = () => (
		<DropMenu position="left" onClose={() => setDropMenuState(false)}>
			<IconTextButton
				text="Share"
				icon={ShareIcon}
				action={() => handleShareButton(index)}
			/>
			<IconTextButton text="View" icon={FocusIcon} action={handleView} />
			<IconTextButton
				text="Duplicate"
				icon={Duplicate}
				action={handleDuplicate}
			/>
			<IconTextButton
				text="Edit"
				icon={EditIcon}
				action={handleEditButton}
			/>
			<IconTextButton
				text="Delete"
				icon={DustbinIcon}
				action={() => handleDeleteButton(index)}
			/>
		</DropMenu>
	);
	return (
		<div className={`${styles.card} ${primaryBoxShadow}`}>
			{showDropMenu ? dropMenu() : null}
			<div className={styles.headBar}>
				<p className={`${titleS} ${fw400} ${secondaryTextColor}`}>
					{!data.shareOption ? "Private" : data.shareOption}
				</p>
				<MoreButton action={handleDropMenu} />
			</div>
			<div className={styles.cardBody} onClick={handleEditButton}>
				<p className={`${titleL} ${fw500} ${primaryTextColor}`}>
					{data.title || "Untitled"}
				</p>
				<div className={styles.slidesCountContainer}>
					<img src={SlidesIcon} alt="Slides Icon" />
					<p
						className={`${titleS} ${fw400} ${secondaryTextColor} ${styles.slidesCount}`}
					>
						{data.slides} Slides
					</p>
				</div>
			</div>
			<div className={styles.bottomBar}>
				<p className={`${titleS} ${fw400} ${secondaryTextColor}`}>
					{getEditedDate()}
				</p>
				<p className={`${titleS} ${fw400} ${secondaryTextColor}`}>
					{getCreatedDate()}
				</p>
			</div>
		</div>
	);
}
